// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Ouroboros_Models_Ui_PasswordResetCompletePhase from "../Ouroboros.Models.Ui.PasswordResetCompletePhase/index.js";
import * as Ouroboros_Models_Ui_VisibilityPhase from "../Ouroboros.Models.Ui.VisibilityPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_PasswordResetComplete from "../Ouroboros.Programs.Controllers.PasswordResetComplete/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var visibilityPhaseFromOption = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.hidden;
})(function (v) {
    return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.visible;
});
var readState = function (v) {
    return v;
};
var optionToString = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return "";
})(/* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn));
var bodyPhaseFromToken = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return Ouroboros_Models_Ui_PasswordResetCompletePhase.passwordResetCompletePhaseNamespace.missingToken;
})(function (v) {
    return Ouroboros_Models_Ui_PasswordResetCompletePhase.passwordResetCompletePhaseNamespace.form;
});
var buildPasswordResetCompleteViewProps = function (input) {
    return {
        password: readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.form.password)),
        confirmPassword: readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.form.confirmPassword)),
        onPasswordChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.form.password))(value);
        },
        onConfirmPasswordChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.form.confirmPassword))(value);
        },
        onSubmit: function (v) {
            return Ouroboros_Programs_Controllers_PasswordResetComplete.runPasswordResetCompleteAction(input.kernel.controller.submit);
        },
        onNavigateToRequest: function (v) {
            return Ouroboros_Programs_Capabilities.runControllerAction(Ouroboros_Programs_Capabilities.runNavigateAction(input.kernel.navigate)(input.requestResetRoute));
        },
        bodyPhase: bodyPhaseFromToken(input.token),
        logoPhase: visibilityPhaseFromOption(input.logoUri),
        logoUri: optionToString(input.logoUri)
    };
};
export {
    buildPasswordResetCompleteViewProps
};
//# sourceMappingURL=index.js.map
